import { ReactNode, useRef, useState } from 'react'
import { styled } from '../../lib/stitches'

const AccordionHeading = styled('div', {
  fontFamily: 'DM Sans',
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: '26px',
  letterSpacing: '-0.02em',
  '@tablet': {
    lineHeight: '20px'
  }
})

const AccordionHeader = styled('div', {
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '20px 0',
  borderBottom: '1px solid black',
  '@tablet': {
    padding: '38px 0'
  }
})

const AccordionContainerWrapper = styled('div', {
  overflow: 'hidden',
  transition: '0.2s',
  height: 0
})

const AccordionContainer = styled('div', {
  padding: '32px',
  borderBottom: '1px solid black'
})

const sharedPlusProps = {
  content: '',
  display: 'block',
  top: '50%',
  width: '100%',
  height: '1.5px',
  position: 'absolute',
  backgroundColor: '#141414',
  borderRadius: 'inherit',
  '@tablet': {
    height: '2px'
  }
}

const PlusIcon = styled('div', {
  width: '15px',
  minWidth: '15px',
  height: '15px',
  minHeight: '15px',
  borderRadius: '1px',
  position: 'relative',
  marginRight: '4px',
  transition: '0.2s',
  '&::after': {
    ...sharedPlusProps,
    transform: 'translateY(-50%) rotate(180deg)'
  },
  '&::before': {
    ...sharedPlusProps,
    transform: 'translateY(-50%) rotate(90deg)'
  },

  '@tablet': {
    width: '20.5px',
    height: '20.5px',
    marginRight: '5.5px'
  }
})

interface IAccordion {
  heading: string
  children: ReactNode | string
}

const Accordion = ({ heading, children }: IAccordion) => {
  const [expanded, setExpanded] = useState(false)
  const accordionContainerRef = useRef<HTMLDivElement>(null)
  const containerHeight = accordionContainerRef.current?.clientHeight

  const handleExpanded = () => setExpanded((prev) => !prev)

  return (
    <div>
      <AccordionHeader onClick={handleExpanded}>
        <AccordionHeading>{heading}</AccordionHeading>
        <PlusIcon
          css={{
            transform: expanded ? 'rotate(-45deg)' : 'rotate(0deg)'
          }}
        />
      </AccordionHeader>
      <AccordionContainerWrapper
        css={{
          height: expanded ? containerHeight : 0
        }}
      >
        <div ref={accordionContainerRef}>
          <AccordionContainer>{children}</AccordionContainer>
        </div>
      </AccordionContainerWrapper>
    </div>
  )
}

export default Accordion
